// extracted by mini-css-extract-plugin
export default {"page":"CustomerPage_page__xxo6t","container":"CustomerPage_container__pp4n8","tabs":"CustomerPage_tabs__fgC8l","active":"CustomerPage_active__pVu9b"};